import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=ca90c7a0&scoped=true"
import script from "./switch.vue?vue&type=script&lang=ts"
export * from "./switch.vue?vue&type=script&lang=ts"
import style0 from "./switch.vue?vue&type=style&index=0&id=ca90c7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca90c7a0",
  null
  
)

export default component.exports